import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

import "./i18n";
import "./assets/css/animate.css";
import "./assets/css/glightbox.min.css";
import "./App.css";

ReactDOM.render(<App />, document.getElementById("root"));
